import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { validateAddEmployeeForm } from "../utils/validation";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class EmployeeAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      dateOfBirth: "",
      gender: "",
      maritalStatus: "",
      fathername: "",
      idNumber: "",
      bankName: "",
      accountName: "",
      accountNumber: "",
      iBan: "",
      isPasswordRequired: false,
      showPassword: false,
      address: "",
      country: "",
      city: "",
      mobile: "",
      phone: "",
      email: "",
      aadharNumber: '',
      ecisNumber: '',
      pfNumber: '',
      panNumber: '',
      username: "",
      password: "",
      role: "",
      department: "",
      departmentId: '',
      reportid: '',
      roleId: '',
      startDate: "",
      endDate: "",
      departments: [],
      employeeList: [],
      roleList: [],
      jobTitle: '',
      joiningDate: "",
      documentsArray: [],
      hasError: false,
      errMsg: "",
      employeeIdWithMaxValue: '',
      completed: false,
      active: "0",
      userId: '',
      nomineeName: "",
      nomineeRelation: "",
      showAddSalary: false,
      successMsg: '',
      addEmployeeStatus: false,
      // for salary 

      departmentsForSalary: [],
      selectedDepartmentForSalary: null,
      selectedUserForSalary: null,
      financialId: null,
      users: [],
      salaryBasic: 0,
      allowanceHouseRent: 0,
      allowanceMedical: 0,
      allowanceSpecial: 0,
      allowanceFuel: 0,
      allowancePhoneBill: 0,
      allowanceOther: 0,
      deductionPF: 0,
      deductionTax: 0,
      deductionOther: 0,
      hasEcis: 'yes',
      hasOT: "yes",
      OtWorkingHours: 0,


      //  toaster 
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: false
    };
  }

  componentDidMount() {
    this.fetchRoleData();
    this.fetchData();
    this.fetchUserIds();
    console.log("  isPasswordRequired", this.state.isPasswordRequired);
  }

  handleChangeEmploymentType = (event) => {
    const { name, value } = event.target
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
    // const { name, value } = event.target
    // this.setState({
    //   [name]: value
    // })
  }



  onEdit(job) {
    return event => {
      event.preventDefault()

      this.setState({ selectedJob: job, showEditModel: true })
    }
  }

  fetchData = async () => {
    this.setState({ loading: true })
    try {
      const departmentResponse = await axios.get("/departments", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      this.setState({ departments: departmentResponse.data });
      const usersResponse = await axios.get("/users", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      this.setState({ employeeList: usersResponse.data, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error("Error fetching data:", error);
    }

  }
  fetchRoleData = async () => {
    this.setState({ loading: true })
    try {
      const usersResponse = await axios.get("/role", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      this.setState({ roleList: usersResponse?.data.roles, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error("Error fetching data:", error);
    }

  }



  fetchUserIds() {
    this.setState({ loading: true });
    axios({
      method: 'get',
      url: `users/maxid`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ employeeIdWithMaxValue: res?.data?.nextid, loading: false })
      })

      .catch(err => {
        console.log("error is here", err)
        this.setState({ loading: false });
      })

  }
  // handleChange = (event) => {
  //   const { value, name } = event.target;
  //   let errors = { ...this.state.errors };
  //   if (value.trim()) {
  //     delete errors[name];
  //   }
  //   this.setState({
  //     [name]: value,
  //     errors
  //   });
  // };
  // handleChange = (event) => {
  //   const { value, name } = event.target;
  //   let errors = { ...this.state.errors };

  //   if ((name === "mobile" || name === "phone") && (!/^\d*$/.test(value) || value.length > 10)) {
  //     return;
  //   }


  //   if ((name === "mobile" || name === "phone") && /^0{10}$/.test(value)) {
  //     return
  //   }

  //   if ((name === "mobile" || name === "phone") && /^0{3,}/.test(value)) {
  //     return;
  //   }

  //   if (name === "password") {
  //     if (!value.trim()) {
  //       errors.password = "Password is required";
  //     } else {
  //       const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  //       if (!strongPasswordRegex.test(value)) {
  //         errors.password = "Password must be at least 8 characters long, contain one uppercase, one lowercase, one number, and one special character.";
  //       } else {
  //         delete errors.password;
  //       }
  //     }
  //   }


  //   // Role Validation (Required)
  //   if (name === "role") {
  //     if (!value) {
  //       errors.role = "Role is required.";
  //     } else {
  //       delete errors.role;
  //     }
  //   }

  //   // Remove error if value is valid

  //   if (value.trim()) {
  //     delete errors[name];
  //   }

  //   this.setState({
  //     [name]: value,
  //     errors
  //   });
  // };
  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (name === "phone" || name === "mobile") {
      const landlinePattern = /^\d{11}$/; // 11-digit format without space

      if (name === "phone") {
        if (!/^\d*$/.test(value) || value.length > 11) {
          return;
        }

        if (value.length < 11) {
          errors.phone = "Landline must have exactly 11 digits";
        } else if (!landlinePattern.test(value)) {
          errors.phone = "Landline must be in the format 07311234567";
        } else {
          delete errors.phone;
        }
      }
      if (name === "pfNumber") {
        const pfValue = value.toUpperCase();
        const pfRegex = /^[A-Z0-9]{5,30}$/;

        // This will catch +, -, spaces, and all special characters
        if (/[^A-Z0-9]/i.test(pfValue)) {
          errors.pfNumber = "PF number must contain only letters and numbers (no symbols)";
        } else if (pfValue.length < 5 || pfValue.length > 30) {
          errors.pfNumber = "PF number must be between 5 and 30 characters";
        } else if (!pfRegex.test(pfValue)) {
          errors.pfNumber = "PF number must be alphanumeric (5–30 characters)";
        } else {
          delete errors.pfNumber;
        }

        this.setState({
          [name]: pfValue,
          errors
        });

        return;
      }

      if (name === "mobile") {
        if (!/^\d*$/.test(value) || value.length > 10) {
          return;
        }

        if (/^0{10}$/.test(value) || /^0{3,}/.test(value)) {
          return;
        }

        if (value.trim() && !/^(?!00)\d{10}$/.test(value)) {
          errors.mobile = "Mobile number must be exactly 10 digits and cannot start with '00'";
        } else {
          delete errors.mobile;
        }
      }
    }
    if (name === "aadharNumber") {
      if (!/^\d*$/.test(value) || value.length > 12) {
        return;
      }

      if (value.length < 12) {
        errors.aadharNumber = "Aadhaar number must be 12 digits";
      } else {
        delete errors.aadharNumber;
      }
    }

    // if (name === "panNumber") {
    //   const panValue = value.toUpperCase(); // Convert to uppercase
    //   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    //   if (panValue.trim() && !panRegex.test(panValue)) {
    //     errors.panNumber = "PAN number must be in the format ABCDE1234F";
    //   } else {
    //     delete errors.panNumber;
    //   }

    //   this.setState({
    //     [name]: panValue, // Ensure PAN is always uppercase
    //     errors
    //   });

    //   return;
    // }
    if (name === "panNumber") {
      let panValue = value.toUpperCase();
      panValue = panValue.replace(/[+-]/g, "");
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (panValue.trim() && !panRegex.test(panValue)) {
        errors.panNumber = "PAN number must be in the format ABCDE1234F";
      } else {
        delete errors.panNumber;
      }
      this.setState({
        [name]: panValue,
        errors
      });
      return;
    }
    if (name === "password") {
      if (!value.trim()) {
        errors.password = "-------sPassword is required";
      } else {
        const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!strongPasswordRegex.test(value)) {
          errors.password = "------Password must be at least 8 characters long, contain one uppercase, one lowercase, one number, and one special character.";
        } else {
          delete errors.password;
        }
      }
    }
    // if (name === "roleId") {
    //   debugger;
    //   if (!value) {
    //     errors.roleId = "Role is required";
    //   } else {
    //     delete errors.roleId;
    //   }
    // }
    if (value.trim()) {
      delete errors[name];
    }

    this.setState({
      [name]: value,
      errors
    });
  };

  handleEcisChange = (event) => {
    const { value } = event.target;
    this.setState({
      hasEcis: value,
      ecisNumber: value === "no" ? "" : this.state.ecisNumber, // Clear ECIS if "No" is selected
    });
  };

  handleOTChange = (event) => {
    this.setState({
      hasOT: event.target.value
    });
  };

  fileSelectedHandler = (event) => {
    this.setState({
      file: event.target.files[0],
    });
  };

  handleCheckboxChange = () => {
    this.setState((prevState) => ({
      isPasswordRequired: !prevState.isPasswordRequired,
      active: !prevState.isPasswordRequired ? 1 : 0,
    }));
  };


  pushDepartments = () => {
    let items = [];
    this.state.departments.map((dept, index) => {
      items.push(
        <option key={index} value={dept.id}>
          {dept.departmentName}
        </option>
      );
    });
    return items;
  };

  pushEmployees = () => {
    let empList = [];
    this.state.employeeList.map((emp, index) => {
      empList.push(
        <option key={index} value={emp.id}>
          {emp.fullName}
        </option>
      );
    });
    return empList;
  };

  pushRoleEmployees = () => {
    let rList = [];
    this.state.roleList.map((role, index) => {
      rList.push(
        <option key={index} value={role.id}>
          {role.name}
        </option>
      );
    });
    return rList;
  };



  handleChangeForSalary = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };

    // Remove non-numeric characters
    let numericValue = value.replace(/\D/g, "").slice(0, 8); // Allows only numbers, max 6 digits

    if (name === "salaryBasic") {
      if (numericValue.trim() === "") {
        errors.salaryBasic = "Salary Basic is required";
      } else if (!/^\d{1,8}$/.test(numericValue)) {
        errors.salaryBasic = "Enter a valid Salary Basic (1-8 digits)";
      } else {
        errors.salaryBasic = ""; // Remove error when valid
      }
    }


    this.setState({
      [name]: numericValue ? Number(numericValue) : + value, // Store as a number, prevent empty NaN
      errors,
    });
  };
  // Start fro add employee
  onSubmit = async (e) => {
    // debugger;
    e.preventDefault();
    this.setState({ hasError: false, errorMsg: "", completed: false });
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    const errors = validateAddEmployeeForm(
      this.state.firstname,
      this.state.lastname,
      this.state.dateOfBirth,
      this.state.gender,
      this.state.maritalStatus,
      this.state.fathername,
      this.state.idNumber,
      this.state.address,
      this.state.country,
      this.state.city,
      this.state.mobile,
      this.state.phone,
      this.state.email,
      this.state.bankName,
      this.state.accountName,
      this.state.accountNumber,
      this.state.iBan,
      this.state.departmentId,
      this.state.nomineeName,
      this.state.nomineeRelation,
      this.state.jobTitle,
      this.state.startDate,
      // this.state.endDate,
      this.state.aadharNumber,
      this.state.ecisNumber,
      this.state.pfNumber,
      this.state.panNumber,
      this.state.reportid,
      this.state.employmentType,
      this.state.salaryBasic,
      this.state.password,
      this.state.roleId,

    );

    if (this.state.isPasswordRequired) {
      if (!this.state.password.trim()) {
        errors.password = "Password is required";
      } else {
        const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!strongPasswordRegex.test(this.state.password)) {
          errors.password = "Password must be at least 8 characters long, contain one uppercase, one lowercase, one number, and one special character.";
        }
      }
      // console.log("Role ID:", this.state.roleId);
      // console.log("pass--required:", this.state.isPasswordRequired);
      if (
        !this.state.roleId ||
        this.state.roleId === "null" ||
        this.state.roleId === null ||
        this.state.roleId === undefined ||
        this.state.roleId.trim?.() === ""
      ) {
        errors.roleId = "Role is required";
      }
      // if (!this.state.roleId || this.state.roleId === 'null') {
      //   errors.role = "Role is required*********";
      // }
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    try {
      // debugger
      const userPayload = {
        username: this.state.employeeIdWithMaxValue,
        password: this.state.password,
        fullname: `${this.state.firstname} ${this.state.lastname}`,
        //role: !(this.state.isPasswordRequired) ? "ROLE_EMPLOYEE" : this.state.role,
        role: "ROLE_ADMIN",
        departmentId: this.state.departmentId,
        reportid: this.state.reportid,
        jobTitle: this.state.jobTitle,
        active: this.state.active,
        roleId: !(this.state.isPasswordRequired) ? "1" : this.state.roleId
      }
      console.log("User Payload:", userPayload);
      const userResponse = await axios.post("/users", userPayload, { headers });
      const userId = userResponse.data.id;
      this.setState({
        userId: userId,
      })
      const personalInfoPayload = {
        dateOfBirth: this.state.dateOfBirth,
        gender: this.state.gender,
        maritalStatus: this.state.maritalStatus,
        fatherName: this.state.fathername,
        idNumber: this.state.idNumber,
        address: this.state.address,
        city: this.state.city,
        country: this.state.country,
        mobile: this.state.mobile,
        phone: this.state.phone,
        emailAddress: this.state.email,
        userId,
      };
      await axios.post("/personalInformations", personalInfoPayload, { headers });
      const financialInfoPayload = {
        bankName: this.state.bankName,
        accountName: this.state.accountName,
        accountNumber: this.state.accountNumber,
        iban: this.state.iBan,
        otStatus: this.state.hasOT,
        OtWorkingHours: this.state.OtWorkingHours,
        esicStatus: this.state.hasEcis,
        userId,
      };
      await axios.post("/financialInformations", financialInfoPayload, { headers });
      const jobPayload = {
        jobTitle: this.state.jobTitle,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        userId,
      };
      await axios.post("/jobs/", jobPayload, { headers });

      const docsPayload = {
        Aadhaar_number: this.state.aadharNumber,
        esic_number: this.state.ecisNumber,
        pf_number: this.state.pfNumber,
        pan_number: this.state.panNumber,
        document: this.state.documentsArray,
        id: userId,
        nominee_name: this.state.nomineeName,
        nominee_relation: this.state.nomineeRelation,
      };
      console.log("docsPayload", docsPayload);


      await axios.post("/employee/", docsPayload, { headers });

      this.setState({
        completed: true,
        // toastMessage: "Employee added successfully!",
        // toastVariant: 'success',
        // color: 'green',
        // showToast: true,
        showAddSalary: true,
        addEmployeeStatus: true
      });
      //window.scrollTo(0, 0);
      // debugger;
    } catch (error) {
      console.log('error', error);
      this.setState({
        hasError: true,
        toastMessage: "Employee not created!",
        toastVariant: 'danger',
        color: 'red',
        errorMsg: error.response?.data?.message || "Something went wrong-------",
      });
      window.scrollTo(0, 0);
    }
  };
  // End fro add employee

  // handleChangeForSalary = (event) => {
  //   const { name, value } = event.target;
  //   let errors = { ...this.state.errors };

  //   if (name === "salaryBasic") {
  //     if (value.trim() === "") {
  //       errors.salaryBasic = "salaryBasic  is required";
  //     } else if (!/^\d{1,6}$/.test(value)) {
  //       errors.salaryBasic = "Enter a valid salaryBasic (1-6 digits)";
  //     } else {
  //       errors.salaryBasic = ""; // Remove error when valid
  //     }
  //   }
  //   if (name === "allowanceMedical") {
  //     if (!/^\d{1,6}$/.test(value)) {
  //       errors.allowanceMedical = "Enter a valid medical allowance (1-6 digits)";
  //     } else {
  //       errors.allowanceMedical = ""; // Remove error when valid
  //     }
  //   }

  //   this.setState({
  //     [name]: +value, // Convert value to number
  //     errors, // Update errors in state
  //   });
  // };



  onSubmitForSalary = async (event) => {
    // debugger

    event.preventDefault();
    this.setState({ hasError: false, errorMsg: "", completed: false, loading: true });
    // const errors = validateSalaryForm(
    //   this.state.employmentType,
    //   this.state.salaryBasic
    // );
    // if (Object.keys(errors).length > 0) {
    //   this.setState({ errors, loading: false });
    //   return;
    // }
    try {
      await this.onSubmit(event);
      console.log("User ID after employee creation:", this.state.userId);
      // Step 2: Prepare Salary Data After Employee is Created
      let data = {
        employmentType: this.state.employmentType,
        salaryBasic: this.state.salaryBasic,
        allowanceHouseRent: this.state.allowanceHouseRent,
        allowanceMedical: this.state.allowanceMedical,
        allowanceSpecial: this.state.allowanceSpecial,
        allowanceFuel: this.state.allowanceFuel,
        allowancePhoneBill: this.state.allowancePhoneBill,
        allowanceOther: this.state.allowanceOther,
        allowanceTotal:
          this.state.allowanceHouseRent +
          this.state.allowanceMedical +
          this.state.allowanceSpecial +
          this.state.allowanceFuel +
          this.state.allowancePhoneBill +
          this.state.allowanceOther,
        deductionProvidentFund: this.state.deductionPF,
        deductionTax: this.state.deductionTax,
        deductionOther: this.state.deductionOther,
        deductionTotal: this.state.deductionTax + this.state.deductionOther + this.state.deductionPF,
        salaryGross:
          this.state.salaryBasic +
          this.state.allowanceHouseRent +
          this.state.allowanceMedical +
          this.state.allowanceSpecial +
          this.state.allowancePhoneBill +
          this.state.allowanceFuel +
          this.state.allowanceOther,
        salaryNet:
          this.state.salaryBasic +
          this.state.allowanceHouseRent +
          this.state.allowanceMedical +
          this.state.allowanceSpecial +
          this.state.allowancePhoneBill +
          this.state.allowanceFuel +
          this.state.allowanceOther -
          this.state.deductionTax -
          this.state.deductionOther -
          this.state.deductionPF,
        userId: this.state.userId,
      };

      // Step 3: Submit Salary Data

      if (this.state.addEmployeeStatus === true) {
        await axios.put(`financialInformations/${this.state.userId}`, data, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        this.setState({
          completed: true,
          toastMessage: "Employee created successfully!",
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        }, () => {
          console.log("Toast should be visible:", this.state.showToast);
          setTimeout(() => {
            this.setState({ showToast: false, loading: false });
            this.props.history.push("/employee-list");
          }, 2000);
        });
      }
      else {
        this.setState({
          hasError: true,
          toastMessage: "Please fill the required fields",
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
          // errorMsg: error.response?.data?.message || "Something went wrong",
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 2000);
      }
      // Step 4: Set success state and scroll to top

      console.log("Toast should be visible:", this.state.showToast);
      window.scrollTo(0, 0);

      // this.props.history.push("/employee-list");
    } catch (error) {
      console.log("Error:", error);
      this.setState({
        hasError: true,
        toastMessage: error.response?.data?.message || "Something went wrong",
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
        // errorMsg: error.response?.data?.message || "Something went wrong",
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
      // window.scrollTo(0, 0);
    }
  };

  handleBack = () => {
    this.props.history.push('/employee-list')
  }
  render() {

    let salaryGross = this.state.salaryBasic + this.state.allowanceHouseRent +
      this.state.allowanceMedical + this.state.allowanceSpecial +
      this.state.allowancePhoneBill + this.state.allowanceFuel +
      this.state.allowanceOther
    let deductionTotal = this.state.deductionTax + this.state.deductionOther + this.state.deductionPF
    let salaryNet = salaryGross - deductionTotal

    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          < >
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>  Add Employee
                </strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  {/* <div className="row"> */}
                  {/* Main Card */}

                  <Card.Body>
                    <div className="row">
                      {/* Personal Details Card */}
                      <div className="col-sm-6">
                        <Card className="shadow-sm rounded border-0 card">
                          <Card.Header>Personal Details</Card.Header>
                          <Card.Body>
                            <>
                              <Form.Group controlId="formFirstName">
                                <Form.Label className="text-muted required">
                                  First Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter first name"
                                  name="firstname"
                                  value={this.state.firstname}
                                  onChange={this.handleChange}

                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.firstname && <small className="text-danger">{this.state.errors.firstname}</small>}
                              </span>
                              <Form.Group controlId="formLastName">
                                <Form.Label className="text-muted required">
                                  Last Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter last name"
                                  name="lastname"
                                  value={this.state.lastname}
                                  onChange={this.handleChange}
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.lastname && <small className="text-danger">{this.state.errors.lastname}</small>}
                              </span>

                              <Form.Group controlId="formDateofBirth">
                                <Form.Label className="text-muted required">
                                  Date of Birth
                                </Form.Label>
                                <Form.Row>
                                  <DatePicker
                                    selected={this.state.dateOfBirth}
                                    onChange={(dateOfBirth) => {
                                      let errors = { ...this.state.errors };
                                      if (dateOfBirth) {
                                        delete errors.dateOfBirth;
                                      }
                                      this.setState({ dateOfBirth, errors });
                                    }}
                                    // onChange={(dateOfBirth) =>
                                    //   this.setState({ dateOfBirth })
                                    // }
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    timeFormat="HH:mm"
                                    name="dateOfBirth"
                                    timeIntervals={30}
                                    timeCaption="time"
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control ml-1"
                                    placeholderText="Select Date Of Birth"
                                    autoComplete="off"
                                  />
                                </Form.Row>
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.dateOfBirth && <small className="text-danger">{this.state.errors.dateOfBirth}</small>}
                              </span>
                              <Form.Group controlId="formGender">
                                <Form.Label className="text-muted required">
                                  Gender
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  className="form-select"
                                  value={this.state.gender}
                                  onChange={this.handleChange}
                                  name="gender"
                                >
                                  <option value="">Choose...</option>
                                  <option value="male">Male</option>
                                  <option value="female">Female</option>
                                </Form.Control>
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.gender && <small className="text-danger">{this.state.errors.gender}</small>}
                              </span>
                              <Form.Group controlId="formMaritalStatus">
                                <Form.Label className="text-muted required">
                                  Marital Status
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  className="form-select"
                                  value={this.state.maritalStatus}
                                  onChange={this.handleChange}
                                  name="maritalStatus"

                                >
                                  <option value="">Choose...</option>
                                  <option value="married">Married</option>
                                  <option value="single">Single</option>
                                </Form.Control>
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.maritalStatus && <small className="text-danger">{this.state.errors.maritalStatus}</small>}
                              </span>
                              <Form.Group controlId="formFatherName">
                                <Form.Label className="text-muted required">
                                  Father's name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter father's name"
                                  name="fathername"
                                  value={this.state.fathername}
                                  onChange={this.handleChange}
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.fathername && <small className="text-danger">{this.state.errors.fathername}</small>}
                              </span>
                              <Form.Group controlId="formId">
                                <Form.Label className="text-muted required">
                                  ID Number
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter id number"
                                  name="idNumber"
                                  value={this.state.idNumber}
                                  onChange={this.handleChange}
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.idNumber && <small className="text-danger">{this.state.errors.idNumber}</small>}
                              </span>
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-sm-6">
                        <Card className="shadow-sm rounded border-0 card">
                          <Card.Header>Contact Details</Card.Header>
                          <Card.Body>
                            <>
                              <Form.Group controlId="formPhysicalAddress">
                                <Form.Label className="text-muted required">
                                  Physical Address
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.address}
                                  onChange={this.handleChange}
                                  name="address"
                                  placeholder="Enter address"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.address && <small className="text-danger">{this.state.errors.address}</small>}
                              </span>
                              <Form.Group controlId="formCountry">
                                <Form.Label className="text-muted required">
                                  Country
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.country}
                                  onChange={this.handleChange}
                                  name="country"
                                  placeholder="Enter country"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.country && <small className="text-danger">{this.state.errors.country}</small>}
                              </span>
                              <Form.Group controlId="formCity">
                                <Form.Label className="text-muted required">
                                  City
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.city}
                                  onChange={this.handleChange}
                                  name="city"
                                  placeholder="Enter city"

                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.city && <small className="text-danger">{this.state.errors.city}</small>}
                              </span>
                              <Form.Group controlId="formMobile">
                                <Form.Label className="text-muted required">
                                  Mobile
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.mobile}
                                  onChange={this.handleChange}
                                  name="mobile"
                                  placeholder="Enter mobile"
                                  maxLength={10}
                                  onPaste={(e) => {
                                    const pastedText = e.clipboardData.getData("Text");
                                    if (!/^\d{1,10}$/.test(pastedText)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.mobile && <small className="text-danger">{this.state.errors.mobile}</small>}
                              </span>
                              <Form.Group controlId="formPhone">
                                <Form.Label className="text-muted">Landline</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={this.state.phone}
                                  onChange={this.handleChange}
                                  name="phone"
                                  placeholder="Enter phone"
                                  maxLength={10}
                                  onPaste={(e) => {
                                    const pastedText = e.clipboardData.getData("Text");
                                    if (!/^\d{1,10}$/.test(pastedText)) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.phone && <small className="text-danger">{this.state.errors.phone}</small>}
                              </span>
                              <Form.Group controlId="formEmail">
                                <Form.Label >
                                  Email
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.email}
                                  onChange={this.handleChange}
                                  name="email"
                                  placeholder="Enter email"

                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.email && <small className="text-danger">{this.state.errors.email}</small>}
                              </span>
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <Card className="shadow-sm rounded border-0 card">
                          <Card.Header>Bank Information</Card.Header>
                          <Card.Body>
                            <>
                              <Form.Group controlId="formBankName">
                                <Form.Label className="text-muted">
                                  Bank Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.bankName}
                                  onChange={this.handleChange}
                                  name="bankName"
                                  placeholder="Enter bank name"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.bankName && <small className="text-danger">{this.state.errors.bankName}</small>}
                              </span>
                              <Form.Group controlId="formAccountName">
                                <Form.Label className="text-muted">
                                  Account Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.accountName}
                                  onChange={this.handleChange}
                                  name="accountName"
                                  placeholder="Enter account name"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.accountName && <small className="text-danger">{this.state.errors.accountName}</small>}
                              </span>
                              <Form.Group controlId="formAccountNumber">
                                <Form.Label className="text-muted">
                                  Account Number
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.accountNumber}
                                  onChange={this.handleChange}
                                  name="accountNumber"
                                  placeholder="Enter account number"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.accountNumber && <small className="text-danger">{this.state.errors.accountNumber}</small>}
                              </span>
                              <Form.Group controlId="formIban">
                                <Form.Label className="text-muted">IFSC Code</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.iBan}
                                  onChange={this.handleChange}
                                  name="iBan"
                                  placeholder="Enter IFSC"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.iBan && <small className="text-danger">{this.state.errors.iBan}</small>}
                              </span>
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-sm-6">
                        <Card className="shadow-sm rounded border-0 card">
                          {/* ---anuruddha---- */}
                          <Card.Header>Official Status</Card.Header>
                          <div className="login-required">
                            <Form.Group controlId="formCheckbox required">
                              <Form.Check
                                type="checkbox"
                                label=" Login required "
                                checked={this.state.isPasswordRequired}
                                onChange={this.handleCheckboxChange}
                              />
                            </Form.Group>
                          </div>
                          <Card.Body>
                            <>
                              <Form.Group controlId="formEmployeeId">
                                <Form.Label className="text-muted required">
                                  Employee ID
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.employeeIdWithMaxValue}
                                  // onChange={this.handleChange}
                                  name="username"
                                  placeholder="Enter username"
                                  readOnly
                                />
                              </Form.Group>
                              <Form.Group controlId="formDepartment">
                                <Form.Label className="text-muted required">
                                  Department
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  className="form-select"
                                  value={this.state.departmentId}
                                  onChange={this.handleChange}
                                  name="departmentId"

                                >
                                  <option value="" defaulvalue='true' disabled>
                                    Choose department...
                                  </option>
                                  {this.pushDepartments()}
                                </Form.Control>
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.departmentId && <small className="text-danger">{this.state.errors.departmentId}</small>}
                              </span>
                              {
                                this.state.isPasswordRequired &&
                                <>

                                  <Form.Group controlId="formPassword">
                                    <Form.Label className="text-muted required">
                                      Password
                                    </Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        type={this.state.showPassword ? "text" : "password"}
                                        value={this.state.password}
                                        onChange={this.handleChange}
                                        name="password"
                                        placeholder="Enter password"
                                        required={this.state.isPasswordRequired}
                                      />
                                      <InputGroup.Append>
                                        <Button
                                          variant="outline-secondary"
                                          onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                        >
                                          {this.state.showPassword ? "Hide" : "Show"}
                                        </Button>
                                      </InputGroup.Append>
                                    </InputGroup>
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.password && <small className="text-danger">{this.state.errors.password}</small>}
                                  </span>

                                  <Form.Group controlId="formRole">
                                    {/* <Form.Control
                                    as="select"
                                      className="form-select" 
                                    value={this.state.role}
                                    onChange={this.handleChange}
                                    name="role"
                                  >
                                    <option value="" disabled>Choose Role...</option>
                                    <option value="ROLE_ADMIN">Admin</option>
                                    <option value="ROLE_MANAGER">Manager</option>
                                    <option value="ROLE_EMPLOYEE">Employee</option>
                                  </Form.Control> */}
                                    <Form.Label className="text-muted required">
                                      Role
                                    </Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.roleId}
                                      onChange={this.handleChange}
                                      name="roleId">
                                      <option value="" defaultValue='true'>
                                        Choose...
                                      </option>
                                      {this.pushRoleEmployees()}
                                    </Form.Control>
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.roleId && (
                                      <small className="text-danger">{this.state.errors.roleId}</small>
                                    )}
                                  </span>
                                  {/* <span className="login-error">
                                  {this.state.errors.role && <small className="text-danger">{this.state.errors.role}</small>}
                                </span> */}
                                </>
                              }
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <Card className="shadow-sm rounded border-0 card">
                          <Card.Header>Nominee Details</Card.Header>
                          <Card.Body>
                            <>
                              <Form.Group controlId="formNomineeName">
                                <Form.Label className="text-muted required">
                                  Nominee Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.nomineeName}
                                  onChange={this.handleChange}
                                  name="nomineeName"
                                  placeholder="Enter nominee name"

                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.nomineeName && <small className="text-danger">{this.state.errors.nomineeName}</small>}
                              </span>
                              <Form.Group controlId="formRelationNomineeName">
                                <Form.Label className="text-muted required">
                                  Relation with Nominee
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.nomineeRelation}
                                  onChange={this.handleChange}
                                  name="nomineeRelation"
                                  placeholder="Enter relation with nominee"

                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.nomineeRelation && <small className="text-danger">{this.state.errors.nomineeRelation}</small>}
                              </span>
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-sm-6">
                        <Card className="shadow-sm rounded border-0 card">
                          <Card.Header>Job Details</Card.Header>
                          <Card.Body>
                            <>
                              <Form.Group controlId="formJobTitle">
                                <Form.Label className="text-muted required">
                                  Job Title
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={this.state.jobTitle}
                                  onChange={this.handleChange}
                                  name="jobTitle"
                                  placeholder="Enter job title"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.jobTitle && <small className="text-danger">{this.state.errors.jobTitle}</small>}
                              </span>
                              <Form.Group controlId="formJobStart">
                                <Form.Label className="text-muted required">Start Date</Form.Label>
                                <Form.Row>
                                  <DatePicker
                                    selected={this.state.startDate}
                                    onChange={(startDate) => {
                                      this.setState((prevState) => ({
                                        startDate,
                                        errors: { ...prevState.errors, startDate: "" },
                                      }));
                                    }}
                                    dropdownMode="select"
                                    timeFormat="HH:mm"
                                    name="startDate"
                                    timeCaption="time"
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control ml-1"
                                    placeholderText="Select Start Date"
                                    autoComplete="off"
                                  />
                                </Form.Row>

                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.startDate && (
                                  <small className="text-danger">{this.state.errors.startDate}</small>
                                )}
                              </span>

                              {/* <Form.Group controlId="formJobEnd">
                              <Form.Label className="text-muted">
                                End Date
                              </Form.Label>
                              <Form.Row>
                                <DatePicker
                                  selected={this.state.endDate}
                                  onChange={(endDate) => {
                                    this.setState((prevState) => ({
                                      endDate,
                                      errors: { ...prevState.errors, endDate: "" },
                                    }));
                                  }}
                                  dropdownMode="select"
                                  timeFormat="HH:mm"
                                  name="endDate"
                                  timeCaption="time"
                                  dateFormat="yyyy-MM-dd"
                                  className="form-control ml-1"
                                  placeholderText="Select end date "
                                  autoComplete="off"
                                />
                              </Form.Row>
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors.endDate && <small className="text-danger">{this.state.errors.endDate}</small>}
                            </span> */}
                            </>
                          </Card.Body>
                        </Card>
                        {/* <Button variant="primary" type="submit" block>
                      Submit
                    </Button> */}
                      </div>
                    </div>
                    <div className="row">
                      <div className=" add-emp-form">
                        <Card className="shadow-sm rounded border-0">
                          <Card.Header className="text-white">Documents Details</Card.Header>
                          <Card.Body>
                            <>
                              <Row>
                                {/* First Column */}
                                <Col sm={6}>
                                  <Form.Group controlId="formAadharNumber">
                                    <Form.Label className="text-muted">Aadhar Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={this.state.aadharNumber}
                                      onChange={this.handleChange}
                                      name="aadharNumber"
                                      placeholder="Enter Aadhar number"
                                      maxLength={12}
                                      onKeyDown={(e) => {
                                        const invalidChars = ['e', 'E', '+', '-', '.'];
                                        if (invalidChars.includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.aadharNumber && <small className="text-danger">{this.state.errors.aadharNumber}</small>}
                                  </span>
                                </Col>

                                {/* Second Column */}
                                <Col sm={6}>
                                  <Form.Group controlId="formPanNumber">
                                    <Form.Label className="text-muted">PAN Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={this.state.panNumber}
                                      onChange={this.handleChange}
                                      name="panNumber"
                                      placeholder="Enter PAN number"
                                    />
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.panNumber && <small className="text-danger">{this.state.errors.panNumber}</small>}
                                  </span>
                                </Col>
                              </Row>

                              <Row>
                                {/* First Column */}
                                <Col sm={6}>
                                  <Form.Group controlId="formEcisNumber">
                                    <Form.Label className="text-muted">ECIS Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={this.state.ecisNumber}
                                      onChange={this.handleChange}
                                      name="ecisNumber"
                                      onKeyDown={(e) => {
                                        if (["+", "-"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      placeholder="Enter ECIS number"
                                      disabled={this.state.hasEcis === "no"}
                                    />
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.ecisNumber && <small className="text-danger">{this.state.errors.ecisNumber}</small>}
                                  </span>
                                </Col>

                                {/* Second Column */}
                                <Col sm={6}>
                                  <Form.Group controlId="formEpfNumber">
                                    <Form.Label className="text-muted">PF Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={this.state.pfNumber}
                                      onChange={this.handleChange}
                                      name="pfNumber"
                                      onKeyDown={(e) => {
                                        if (["+", "-"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      placeholder="Enter PF number"
                                    />
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.pfNumber && <small className="text-danger">{this.state.errors.pfNumber}</small>}
                                  </span>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="status-esic">
                                    <p className="radio_class">ESIC Status</p>
                                    <div className="d-flex gap-4 border rounded p-2 bg-light">
                                      <Form.Check

                                        label="Yes"
                                        type="radio"
                                        name="hasEcis"
                                        value="yes"
                                        checked={this.state.hasEcis === "yes"}
                                        onChange={this.handleEcisChange}
                                      />
                                      <Form.Check

                                        label="No"
                                        type="radio"
                                        name="hasEcis"
                                        value="no"
                                        checked={this.state.hasEcis === "no"}
                                        onChange={this.handleEcisChange}
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <Form.Group controlId="formDepartmentEmployee">
                                    <Form.Label className="text-muted required">Report To</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.reportid} onChange={this.handleChange} name="reportid">
                                      <option value="" defaultValue>
                                        Choose...
                                      </option>
                                      {this.pushEmployees()}
                                    </Form.Control>
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.reportid && <small className="text-danger">{this.state.errors.reportid}</small>}
                                  </span>
                                </Col>

                              </Row>
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </Card.Body>

                  {/* </div> */}

                </Form>
                {/* </Card.Body>
            </Card>
            <Card>
              // <Card.Body> */}
                <Card.Body>
                  <Form onSubmit={this.onSubmitForSalary}>
                    <div className="row">
                      <div>
                        <Card className="main-card shadow-sm rounded border-0">
                          <Card.Header>Salary Details</Card.Header>
                          <Card.Body>
                            <>
                              <Row>

                                <Col sm={3}>
                                  <Form.Group>
                                    <Form.Label className="required radio_class">Employment Type</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      // className="select-css"
                                      value={this.state.employmentType}
                                      onChange={this.handleChangeEmploymentType}
                                      name="employmentType"
                                    >
                                      <option value="">Choose one...</option>
                                      <option value="Full Time">Full Time</option>
                                      <option value="Part Time">Part Time</option>
                                    </Form.Control>
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.employmentType && (
                                      <small className="text-danger">{this.state.errors.employmentType}</small>
                                    )}
                                  </span>
                                </Col>

                                <Col sm={3}>
                                  <Form.Group>
                                    <Form.Label className="required radio_class">Basic Salary</Form.Label>
                                    <Form.Control
                                      type="number"
                                      value={this.state.salaryBasic}
                                      onChange={this.handleChangeForSalary}
                                      name="salaryBasic"
                                      placeholder="Enter basic salary"
                                    // inputMode="numeric"
                                    // pattern="[0-9]*"
                                    />
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.salaryBasic && (
                                      <small className="text-danger">{this.state.errors.salaryBasic}</small>
                                    )}
                                  </span>
                                </Col>
                                <Col sm={3}>
                                  <Form.Group>
                                    <Form.Label className="radio_class" >Overtime (OT)</Form.Label>
                                    <div className="d-flex gap-4 border rounded p-1 bg-light">

                                      <Form.Check
                                        label="Yes"
                                        type="radio"
                                        name="hasOT"
                                        className="for-check"
                                        value="yes"
                                        checked={this.state.hasOT === "yes"}
                                        onChange={this.handleOTChange}
                                      />
                                      <Form.Check

                                        label="No"
                                        type="radio"
                                        name="hasOT"
                                        value="no"
                                        checked={this.state.hasOT === "no"}
                                        onChange={this.handleOTChange}
                                      />
                                    </div>

                                  </Form.Group>
                                </Col>
                                <Col sm={3}>
                                  <Form.Group>
                                    <Form.Label className=" radio_class">Working Hours(OT)</Form.Label>
                                    <Form.Control
                                      type="number"
                                      value={this.state.OtWorkingHours}
                                      onChange={this.handleChangeForSalary}
                                      name="OtWorkingHours"
                                      placeholder="Enter Working Hours"
                                    // inputMode="numeric"
                                    // pattern="[0-9]*"
                                    />
                                  </Form.Group>
                                  <span className="login-error">
                                    {this.state.errors.OtWorkingHours && (
                                      <small className="text-danger">{this.state.errors.OtWorkingHours}</small>
                                    )}
                                  </span>
                                </Col>
                              </Row>
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-4">
                        <Card className="main-card shadow-sm rounded border-0">
                          <Card.Header>Allowances</Card.Header>
                          <Card.Body>
                            <>
                              <Form.Group>
                                <Form.Label className="radio_class">House Rent Allowance</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={this.state.allowanceHouseRent}
                                  onChange={this.handleChangeForSalary}
                                  name="allowanceHouseRent"
                                />
                              </Form.Group>
                              <Form.Group>
                                <Form.Label className="radio_class">Medical Allowance</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={this.state.allowanceMedical}
                                  onChange={this.handleChangeForSalary}
                                  name="allowanceMedical"
                                />
                              </Form.Group>
                              <span className="login-error">
                                {this.state.errors.allowanceMedical && (
                                  <small className="text-danger">{this.state.errors.allowanceMedical}</small>
                                )}
                              </span>
                              <Form.Group>
                                <Form.Label className="radio_class">Special Allowance</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={this.state.allowanceSpecial}
                                  onChange={this.handleChangeForSalary}
                                  name="allowanceSpecial"
                                />
                              </Form.Group>
                              <Form.Group>
                                <Form.Label className="radio_class">Fuel Allowance</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={this.state.allowanceFuel}
                                  onChange={this.handleChangeForSalary}
                                  name="allowanceFuel"
                                />
                              </Form.Group>
                              <Form.Group>
                                <Form.Label className="radio_class">Food Allowance</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={this.state.allowancePhoneBill}
                                  onChange={this.handleChangeForSalary}
                                  name="allowancePhoneBill"
                                />
                              </Form.Group>
                              <Form.Group>
                                <Form.Label className="radio_class">Other Expenses</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={this.state.allowanceOther}
                                  onChange={this.handleChangeForSalary}
                                  name="allowanceOther"
                                />
                              </Form.Group>
                            </>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-sm-4">
                        <div className="row">
                          <div className="col-sm-12">
                            <Card className="main-card deduction-card shadow-sm rounded border-0">
                              <Card.Header>Deductions</Card.Header>
                              <Card.Body>
                                <>
                                  <Form.Group>
                                    <Form.Label className="radio_class">PF Deduction</Form.Label>
                                    <Form.Control
                                      type="number"
                                      value={this.state.deductionPF}
                                      onChange={this.handleChangeForSalary}
                                      name="deductionPF"
                                    />
                                  </Form.Group>
                                  <Form.Group>
                                    <Form.Label className="radio_class">Tax Deduction</Form.Label>
                                    <Form.Control
                                      type="number"
                                      value={this.state.deductionTax}
                                      onChange={this.handleChangeForSalary}
                                      name="deductionTax"
                                    />
                                  </Form.Group>
                                  <Form.Group>
                                    <Form.Label className="radio_class">Other Deduction</Form.Label>
                                    <Form.Control
                                      type="number"
                                      value={this.state.deductionOther}
                                      onChange={this.handleChangeForSalary}
                                      name="deductionOther"
                                    />
                                  </Form.Group>
                                </>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                        <div className="row">

                        </div>

                      </div>
                      <div className="col-sm-4">
                        <Card className="main-card salary-card shadow-sm rounded border-0">
                          <Card.Header>Total Salary Details</Card.Header>
                          <Card.Body>
                            <>
                              <Form.Group>
                                <Form.Label className="radio_class">Gross Salary</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={salaryGross}
                                  readOnly
                                />
                              </Form.Group>
                              <Form.Group>
                                <Form.Label className="radio_class">Total Deductions</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={deductionTotal}
                                  readOnly
                                />
                              </Form.Group>
                              <Form.Group>
                                <Form.Label className="radio_class">Net Salary</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={salaryNet}
                                  readOnly
                                />
                              </Form.Group>
                            </>
                          </Card.Body>
                        </Card>
                        <div className="row">
                          <div className="col-sm-6">
                            <Button type="submit" variant='primary' className=" align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" block>Add</Button>
                          </div>
                          <div className="col-sm-6">
                            <Button type="submit" variant='danger' className=" align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" block onClick={this.handleBack}>Cancel</Button>
                          </div>
                        </div>

                      </div >
                    </div >

                  </Form >
                </Card.Body>
              </Card.Body>
            </Card>
          </>

        </CommonLoader >
      </div>
    );
  }
}
